import { OlxAdvertItem } from '../../../../../modules/crm/power-olx-v2/interfaces/power-olx-v2.interface';

export interface BuyOlxAdsBundlesPayload {
  channel_id: string;
  adverts: OlxAdvertItem[];
  planner_id?: string;
}

export enum BundleSourceType {
  Bundle = 'bundle',
  Vas = 'vas',
}

export interface BundleTypeConfig {
  type: string;
  product_id: string;
  label: string;
  source: BundleSourceType;
}

export const BUNDLES_TYPES: BundleTypeConfig[] = [
  {
    type: 'pushup',
    product_id: 'pushup',
    label: 'Підняття вгору списку',
    source: BundleSourceType.Vas,
  },
  // {
  //   type: 'pushup',
  //   product_id: 'pushup_automatic',
  //   label: 'Підняти 7 разів',
  //   source: BundleSourceType.Vas,
  // },
  {
    type: 'mini',
    product_id: 'bundle_basic',
    label: 'Легкий старт',
    source: BundleSourceType.Bundle,
  },
  {
    type: 'midi',
    product_id: 'bundle_optimum',
    label: 'Швидкий продаж',
    source: BundleSourceType.Bundle,
  },
  {
    type: 'maxi',
    product_id: 'bundle_premium',
    label: 'Турбо продаж',
    source: BundleSourceType.Bundle,
  },
];

export type OlxAdsBundleData = OlxAdsBundleDataMulti | OlxAdsBundleDataSingle;

type OlxAdsBundleDataMulti = OlxAdBundleItem[];

export interface OlxAdBundleItem {
  ad_id: number;
  ad_title: string;
  bundles: OlxAdsBundleProduct[];
  vas_list: OlxAdsBundleProduct[];
}

export interface OlxAdsBundleProduct {
  product_id: string;
  type: string;
  pricing: {
    regular: {
      raw: number;
      formatted: string;
    };
  };
  enabled: boolean;
}

interface OlxAdsBundleDataSingle {
  bundles: OlxBundleDetails[];
  vas_list: OlxVasDetails[];
}

interface OlxBundleDetails {
  product_id: string;
  type: string;
  label: string;
  label_long: string;
  description: OlxTemplate;
  description_long: OlxTemplate;
  pricing: {
    regular: {
      raw: number;
      formatted: string;
    };
  };
  enabled: boolean;
  preselected: boolean;
  significantly_exceeds_ad_expiration: boolean;
  features: OlxFeature[];
  uplift: {
    percent_uplift: string;
    times_uplift: string;
    no_of_views_uplift: string;
  };
}

export interface OlxVasDetails {
  product_id: string;
  type: string;
  label: OlxTemplate;
  pricing: {
    regular: {
      raw: number;
      formatted: string;
    };
  };
  enabled: boolean;
  preselected: boolean;
  significantly_exceeds_ad_expiration: boolean;
  description: OlxTemplateWithVars;
  extended_description: OlxExtendedDescription;
  duration: string;
  is_crm?: boolean;
}

interface OlxTemplate {
  template: string;
  variables: any[];
}

interface OlxTemplateWithVars {
  template: string;
  variables: Record<string, string>;
}

interface OlxExtendedDescription {
  title: string;
  benefits: string[];
  description: string;
}

interface OlxFeature {
  type: string;
  label: OlxTemplate;
  enabled: boolean;
  description: OlxTemplateWithVars;
  extended_description: OlxExtendedDescription;
}

export interface SelectedAdsBundle {
  advert_id: number;
  code: string;
}

export interface BuyAdsBundlesPayload {
  selected_bundles: SelectedAdsBundle[];
}

export const PUSHUP_VAS_BUNDLE = {
  product_id: 'pushup',
  type: 'pushup',
  pricing: { regular: { raw: 900 } },
  description: { template: 'Підняття вгору списку' },
  is_crm: true,
};
